import React from 'react'
import PayPalNavigation from 'components/common/paypal_navigation'
import Header from 'marketing-components/dist/components/organisms/header'

const RenderHeader = () => {
  const headerContent = document.getElementById('data-header')?.innerHTML
  if (headerContent) {
    try {
      const {
        content: { contentLoggedOut: content, config },
      } = JSON.parse(headerContent)
      const props = { content, config }

      return (
        <div styleName={'marketing-header-background'}>
          <Header {...props} />
        </div>
      )
    } catch (error) {
      return <PayPalNavigation element="desktopHeaderHtml" />
    }
  } else {
    return <PayPalNavigation element="desktopHeaderHtml" />
  }
}

export default RenderHeader
